var map = {
	"./BCI.png": 6831,
	"./BICE.png": 840,
	"./banco-chile.png": 4573,
	"./banco-estado.png": 9588,
	"./banco-falabella.png": 5081,
	"./banco-internacional.png": 4189,
	"./banco-ripley.png": 4866,
	"./banco-security.png": 9219,
	"./consorcio.png": 673,
	"./coopeuch.png": 4970,
	"./corpbanca.png": 4351,
	"./itau.png": 1273,
	"./mach.png": 9187,
	"./santander.png": 2061,
	"./scotiabank.png": 5426,
	"./tenpo.png": 821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2905;